import angular from 'angular'
import $ from 'jquery'

export default angular.module('adminPanel.helpers', []).factory('watcherCount', function() {
  return function() {
    var root = $(document.getElementsByTagName('body'))
    var watchers = []

    var f = function(element) {
      if (element.data().hasOwnProperty('$scope')) {
        angular.forEach(element.data().$scope.$$watchers, function(watcher) {
          watchers.push(watcher)
        })
      }

      angular.forEach(element.children(), function(childElement) {
        f($(childElement))
      })
    }

    f(root)

    return watchers.length
  }
})
